/**
 * @generated SignedSource<<60f315d119b0c481a6001944bc97eb42>>
 * @lightSyntaxTransform
 * @nogrep
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import { ConcreteRequest, Mutation } from 'relay-runtime';
export type UpdateAutoReplyInput = {
  enabled: boolean;
  fromName: string;
  fromEmail: string;
  bodyHtml: string;
  csrfToken?: string | null;
  socketClientId?: string | null;
  clientMutationId?: string | null;
};
export type useUpdateAutoReplyMutation$variables = {
  input: UpdateAutoReplyInput;
};
export type useUpdateAutoReplyMutation$data = {
  readonly updateAutoReply: {
    readonly clientMutationId: string | null;
    readonly autoReply: {
      readonly enabled: boolean;
      readonly fromName: string;
      readonly fromEmail: string;
      readonly bodyHtml: string;
    } | null;
  } | null;
};
export type useUpdateAutoReplyMutation = {
  variables: useUpdateAutoReplyMutation$variables;
  response: useUpdateAutoReplyMutation$data;
};

const node: ConcreteRequest = (function(){
var v0 = [
  {
    "defaultValue": null,
    "kind": "LocalArgument",
    "name": "input"
  }
],
v1 = [
  {
    "alias": null,
    "args": [
      {
        "kind": "Variable",
        "name": "input",
        "variableName": "input"
      }
    ],
    "concreteType": "UpdateAutoReplyPayload",
    "kind": "LinkedField",
    "name": "updateAutoReply",
    "plural": false,
    "selections": [
      {
        "alias": null,
        "args": null,
        "kind": "ScalarField",
        "name": "clientMutationId",
        "storageKey": null
      },
      {
        "alias": null,
        "args": null,
        "concreteType": "AutoReplyConfig",
        "kind": "LinkedField",
        "name": "autoReply",
        "plural": false,
        "selections": [
          {
            "alias": null,
            "args": null,
            "kind": "ScalarField",
            "name": "enabled",
            "storageKey": null
          },
          {
            "alias": null,
            "args": null,
            "kind": "ScalarField",
            "name": "fromName",
            "storageKey": null
          },
          {
            "alias": null,
            "args": null,
            "kind": "ScalarField",
            "name": "fromEmail",
            "storageKey": null
          },
          {
            "alias": null,
            "args": null,
            "kind": "ScalarField",
            "name": "bodyHtml",
            "storageKey": null
          }
        ],
        "storageKey": null
      }
    ],
    "storageKey": null
  }
];
return {
  "fragment": {
    "argumentDefinitions": (v0/*: any*/),
    "kind": "Fragment",
    "metadata": null,
    "name": "useUpdateAutoReplyMutation",
    "selections": (v1/*: any*/),
    "type": "Mutation",
    "abstractKey": null
  },
  "kind": "Request",
  "operation": {
    "argumentDefinitions": (v0/*: any*/),
    "kind": "Operation",
    "name": "useUpdateAutoReplyMutation",
    "selections": (v1/*: any*/)
  },
  "params": {
    "cacheID": "58891551690357440d5b8828313fb14a",
    "id": null,
    "metadata": {},
    "name": "useUpdateAutoReplyMutation",
    "operationKind": "mutation",
    "text": "mutation useUpdateAutoReplyMutation(\n  $input: UpdateAutoReplyInput!\n) {\n  updateAutoReply(input: $input) {\n    clientMutationId\n    autoReply {\n      enabled\n      fromName\n      fromEmail\n      bodyHtml\n    }\n  }\n}\n"
  }
};
})();

(node as any).hash = "fe932205b6bcc735aa622d62fb42fdce";

export default node;
